export default __webpack_public_path__ + "5cd034a3c6f4cd68eb7f92d2b9a3e099.png";